import { PlusOutlined } from '@ant-design/icons';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppTable } from 'shared/UI/UIKit/Table';
import { AppButton } from 'shared/UI/UIKit/Button';
import { TableColumnsFilter } from 'common/ColumnsFilter/ColumnsFilter';
import { useEducationPlans } from '../model';
import styles from './styles.module.scss';

export const EducationPlans = () => {
  const { state, methods } = useEducationPlans();
  const {
    dataSource,
    loading,
    columns,
    filteredColumns,
    visibleKeys,
    lastSyncDate,
    syncInProgress,
  } = state;
  const { handleViewEducationPlan, handleCreateEducationPlan, syncHandler, setVisibleKeys } =
    methods;

  return (
    <AppFlex direction="column" unit="16">
      <AppFlex direction="row" unit="8" justifyContent="flex-end">
        <AppFlex direction="column" unit="2">
          <AppButton className={styles['sync-button']} onClick={syncHandler}>
            Получить учебные планы
          </AppButton>
          {lastSyncDate && (
            <span className={styles['last-sync-date']}>
              Дата последнего получения: {lastSyncDate}
            </span>
          )}
        </AppFlex>
        <AppButton
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleCreateEducationPlan}
          style={{ width: 'fit-content' }}
        >
          Создать учебный план
        </AppButton>
        <TableColumnsFilter
          visibleKeys={visibleKeys}
          columns={columns}
          setVisibleKeys={setVisibleKeys}
        />
      </AppFlex>
      <AppTable
        columns={filteredColumns}
        dataSource={dataSource}
        loading={loading || syncInProgress}
        rowKey={(record) => record?.id ?? ''}
        onRow={(record) => ({
          onClick: () => handleViewEducationPlan(record?.id ?? 0),
        })}
      />
    </AppFlex>
  );
};
